import { render } from "./ModalView.vue?vue&type=template&id=fba22bb2"
const script = {}

import "./ModalView.vue?vue&type=style&index=0&id=fba22bb2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__